import { useEffect, useState } from "react";
import api from "../services/api";

export function useNotifications(params = {}) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    setLoading(true);
    const res = await api.get("/notifications", { params });
    setData(res.data.data);
    setTotal(res.data.meta.total);
    setLoading(false);
  };

  const markAsRead = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    fetchNotifications();
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return {
    data,
    total,
    loading,
    markAsRead,
    refetch: fetchNotifications,
  };
}
